import React, { Component, useState, useEffect } from 'react'
import Article from './Article'
import shortid from "shortid";
import './ArticleRendering/Accordion.css'

function ArticleContainer({ containerObject, templateName, contentId, dataZone }) {
  const [ContTitle, setContTitle] = useState('')
  var titleStyle = containerObject.attributes.titleStyle;
  useEffect(() => {
    var hash = window.location.hash;
    if (hash) {
      var element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }

  }, [])
  return (
    <div data-cont-id={containerObject.contentId} 
    style={containerObject?containerObject.backgroundImage?{ backgroundImage: `url(${containerObject.backgroundImage})`}:{}:{}}
    //style={{ backgroundImage: `url(${containerObject.backgroundImage})`, width: '100%' }}
    data-zone={dataZone} data-page-id={contentId} data-template-name={templateName}
     className={`vast-plugin-content row mx-0 my-3 ${containerObject.attributes.class ? containerObject.attributes.class : containerObject.attributes.articleContainerRendering ? containerObject.attributes.articleContainerRendering : ("col-md-12")}`} id={containerObject.attributes.ArticleId ?containerObject.attributes.ArticleId :""}>
     <span className={`${containerObject.attributes.horizontalLine ? containerObject.attributes.horizontalLine :"" }`}> </span>
     
     {containerObject.backgroundVideo ?
                        <iframe src={`${containerObject.backgroundVideo}`} style={{ width: '100%', backgroundRepeat: 'no-repeat' }} className='img-fluid' /> : ""}
       
       {containerObject.containerTitle?
        titleStyle === 'h1' ? <h1 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`}  dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h1> : ""
        
        :""}
         {containerObject.containerTitle?
        titleStyle === 'h2' ? <h2 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`} dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h2> : ""
        
        :""}
         {containerObject.containerTitle?
        titleStyle === 'h3' ? <h3 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`}  dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h3> : ""
        
        :""}
         {containerObject.containerTitle?
        titleStyle === 'h4' ? <h4 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`}  dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h4> : ""
        
        :""}
         {containerObject.containerTitle?
        titleStyle === 'h5' ? <h5 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`}  dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h5> : ""
        
        :""}
         {containerObject.containerTitle?
        titleStyle === 'h6' ? <h6 className={` ${containerObject.attributes.justifyContent === 'true' ? 'justify-content-center d-flex': " "}`} dangerouslySetInnerHTML={{ __html: containerObject.containerTitle }}></h6> : ""
        
        :""}
        
        {containerObject.articles.map((content ,index) => {
          return <Article articleIndex={index}   key={shortid.generate()} articleObj={content} ></Article>
        })}
        
    </div>
    
  )
}

export default ArticleContainer
